import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import { getLoggedinUser } from './helpers/api_helper';

const persistedUser = getLoggedinUser();
const store = configureStore({ 
  reducer: rootReducer, 
  preloadedState: {
    Profile: {
      user: persistedUser?.user,
      error: null,
    },
  },
  devTools: true 
});

const ErrorBoundary = () => {
  return (
    <div>
      <h2>Something went wrong!</h2>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
    errorElement: <ErrorBoundary />,
  }
], {
  basename: process.env.PUBLIC_URL // Add basename here
});


ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);